// extracted by mini-css-extract-plugin
export default {"icon":"mfr-PQmBN8El"};